require('./formBuilder.tpl.html');
require('./componentPalette/componentPaletteComponent.js');
require('./componentSettings/componentSettingsComponent.js');
require('./leftNav/formBuilderLeftNavComponent.js');

/*@ngInject*/
const FormBuilderController = function ($scope, $stateParams, coreConstant) {

    $scope.viewModel = {
        uiFormTemplateId: parseInt($stateParams.uiFormTemplateId),
        isCollapsibleLeftNavOpen: true
    };

    $scope.$on(coreConstant.event.COLLAPSIBLE_LEFT_NAV_OPENED, function () {
        $scope.viewModel.isCollapsibleLeftNavOpen = true;
    });

    $scope.$on(coreConstant.event.COLLAPSIBLE_LEFT_NAV_CLOSED, function () {
        $scope.viewModel.isCollapsibleLeftNavOpen = false;
    });
};

angular.module('ums.configuration')
    .controller('formBuilderController', FormBuilderController);
